import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGS } from "./i18n";

const BASE_URL = "https://aitradingpredictions.com";

function Seo({ title, description, canonical, type = "website", schema, breadcrumbs }) {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const canonicalPath = canonical || "";
  const url = SUPPORTED_LANGS.includes(currentLang)
    ? `${BASE_URL}/${currentLang}${canonicalPath}`
    : `${BASE_URL}${canonicalPath}`;

  const hreflangLinks = [
    { lang: "en",        href: `${BASE_URL}${canonicalPath}` },
    ...SUPPORTED_LANGS.map((lang) => ({
      lang,
      href: `${BASE_URL}/${lang}${canonicalPath}`,
    })),
    { lang: "x-default", href: `${BASE_URL}${canonicalPath}` },
  ];

  const breadcrumbSchema = breadcrumbs
    ? {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumbs.map((crumb, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: crumb.name,
          item: `${BASE_URL}${crumb.path}`,
        })),
      }
    : null;

  const schemas = Array.isArray(schema) ? schema : schema ? [schema] : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="A.I. Trading Predictions" />
      <meta property="og:image" content={`${BASE_URL}/og-image.png`} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {hreflangLinks.map(({ lang, href }) => (
        <link key={lang} rel="alternate" hreflang={lang} href={href} />
      ))}
      {breadcrumbSchema && (
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      )}
      {schemas.map((item, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(item)}</script>
      ))}
    </Helmet>
  );
}

export default Seo;
